import { loadTrainingDrill, type TrainingDrill } from '@/lib/training-program/drill-loader';

export type OptionalDrillCategory = 'putting' | 'shortGame' | 'bunker';

const OPTIONAL_DRILL_SLUGS: Record<OptionalDrillCategory, string[]> = {
  putting: ['own-short-putts', 'speed-window-control', 'straight-start-gate'],
  shortGame: ['low-runner-landing', 'consistent-arm-length'],
  bunker: ['clean-sand-entry', 'forward-base-splash'],
};

export const loadOptionalDrillCatalog = async () => {
  const categories = Object.keys(OPTIONAL_DRILL_SLUGS) as OptionalDrillCategory[];
  const entries = await Promise.all(
    categories.map(async (category) => {
      const drills = await Promise.all(
        OPTIONAL_DRILL_SLUGS[category].map((slug) => loadTrainingDrill(slug))
      );
      return [category, drills.filter(Boolean) as TrainingDrill[]] as const;
    })
  );

  return entries.reduce<Record<OptionalDrillCategory, TrainingDrill[]>>((acc, [category, drills]) => {
    acc[category] = drills;
    return acc;
  }, {
    putting: [],
    shortGame: [],
    bunker: [],
  });
};
